// auto-generated by Typewriter template _models.tst from PortCall.EndPoints\App\PersonProfilePopup\PersonProfilePopupViewModel.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';
import { PCUser, PCUserData, PCUserOptions } from 'data/models/PCUser';

// PersonProfilePopupResponseData is the class that PersonProfilePopupResponse serializes to/from
export interface PersonProfilePopupResponseData {
    UserId : number;
	
    PCUser : PCUserData | null;
	
    CanEdit : boolean;
}

// PersonProfilePopupResponseOptions is the class which may be passed to the PersonProfilePopupResponse constructor to define optional initial data values
export interface PersonProfilePopupResponseOptions {
    UserId : number;
	
    PCUser? : PCUserOptions | null;
	
    CanEdit? : boolean;
}

export class PersonProfilePopupResponse {
    public UserId : DataSignal<number>;
	
    public PCUser : DataSignal<PCUser | null>;
	
    public CanEdit : DataSignal<boolean>;

    constructor();
    constructor(data : PersonProfilePopupResponseOptions);
    constructor(data: PersonProfilePopupResponseOptions | null = null) {
        this.UserId = jsonableObservable(S.value<number>(data && data.UserId !== undefined ? data.UserId : 0));
	    
        this.PCUser = S.value<PCUser | null>(null);
	    
        this.CanEdit = jsonableObservable(S.value<boolean>(data && data.CanEdit !== undefined ? data.CanEdit : false));
    }

    static key(obj : PersonProfilePopupResponse) {
        return obj.UserId();
    }
    
    static dataKey(obj : PersonProfilePopupResponseOptions) {
        return obj.UserId;
    }

    static update(obj : PersonProfilePopupResponse, data : PersonProfilePopupResponseOptions) {
        S.freeze(() => {
            if (data.UserId !== undefined) obj.UserId(data.UserId);
	        
	        
            if (data.CanEdit !== undefined) obj.CanEdit(data.CanEdit);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/PersonProfilePopupResponse.ts